// extracted by mini-css-extract-plugin
export default {"mainContainer":"style_mainContainer__87G2a","upperSection":"style_upperSection__I3nYe"};